/**
 * v-visible directive: like v-show, but toggles `visibility` so a hidden
 * element keeps its space in the layout.
 *
 * <v-progress-linear v-visible="isLoading" indeterminate></v-progress-linear>
 */

import type {App, Directive} from 'vue';

export const visibleDirective: Directive<HTMLElement, boolean> = {
   beforeMount(el: HTMLElement, binding) {
      el.style.visibility = binding.value ? 'visible' : 'hidden';
   },
   updated(el: HTMLElement, binding) {
      el.style.visibility = binding.value ? 'visible' : 'hidden';
   },
};

/** Register the directive globally as `v-visible`. */
export function installVisible(app: App): void {
   app.directive('visible', visibleDirective);
}
